// src/services/orderService.ts
import { supabase } from './supabase';

// Создать заказ через RPC функцию
export const createOrder = async (orderData: {
    delivery_address: string;
    customer_phone: string;
    customer_name: string;
    payment_method?: string;
    delivery_method?: string;
    delivery_price?: number;
    notes?: string;
    country_code?: string;
    commission_percent?: number;
}) => {
    // Получаем текущего пользователя напрямую из Supabase Auth
    const { data: { session }, error: authError } = await supabase.auth.getSession();

    if (authError || !session?.user) {
        console.error('Auth error:', authError);
        throw new Error('Пользователь не авторизован. Пожалуйста, войдите в аккаунт.');
    }

    const userId = session.user.id;

    console.log('📦 Creating order for customer:', userId);
    console.log('📞 Phone (raw):', orderData.customer_phone);
    console.log('🚚 Delivery method:', orderData.delivery_method);
    console.log('💰 Delivery price:', orderData.delivery_price);

    // Передаем все параметры в RPC
    const { data, error } = await supabase
        .rpc('create_order_with_items', {
            p_customer_id: userId,  // Используем ID из сессии
            p_delivery_address: orderData.delivery_address,
            p_customer_phone: orderData.customer_phone,
            p_customer_name: orderData.customer_name,
            p_payment_method: orderData.payment_method || 'cash',
            p_delivery_method: orderData.delivery_method || 'courier',
            p_delivery_price: orderData.delivery_price ?? 0,
            p_notes: orderData.notes || null,
            p_country_code: orderData.country_code || 'TJ'
        });

    if (error) {
        console.error('RPC Error:', error);
        throw error;
    }

    console.log('✅ Order created:', data);
    return data;
};

// Получить список заказов пользователя
export const fetchOrders = async () => {
    const { data: { session } } = await supabase.auth.getSession();

    if (!session?.user) {
        throw new Error('Пользователь не авторизован');
    }

    const { data, error } = await supabase
        .from('customer_orders')
        .select(`
            *,
            items:customer_order_items(
                *,
                product:products(*),
                variant:product_variants(*)
            )
        `)
        .eq('customer_id', session.user.id)
        .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
};

// Получить детали заказа по ID
export const fetchOrderById = async (orderId: string) => {
    const { data: { session } } = await supabase.auth.getSession();

    if (!session?.user) {
        throw new Error('Пользователь не авторизован');
    }

    const { data, error } = await supabase
        .from('customer_orders')
        .select(`
            *,
            items:customer_order_items(
                *,
                product:products(*),
                variant:product_variants(*)
            )
        `)
        .eq('id', orderId)
        .eq('customer_id', session.user.id)
        .single();

    if (error) throw error;
    return data;
};

// Отменить заказ
export const cancelOrder = async (orderId: string) => {
    const { data: { session } } = await supabase.auth.getSession();

    if (!session?.user) {
        throw new Error('Пользователь не авторизован');
    }

    const { data, error } = await supabase
        .rpc('cancel_order', {
            p_order_id: orderId,
            p_customer_id: session.user.id
        });

    if (error) throw error;
    return data;
};